module.exports = __webpack_public_path__ + "img/empty.893e761a.png";